import { colors } from 'styles/variables';

const { lPink, lGrey0, lGrey1, lGrey2 } = colors;

const imageLibraryColors = {
  blue0: '#eaefff',
  blue1: '#c9d7f4',
  lightGrey: '#eaefff',
};

const thumbnailsContainerHeight = (offset: number = 250) =>
  `calc(100vh - ${offset}px)`;

export default {
  ...colors,
  ...imageLibraryColors,
  thumbnailsContainerHeight,
};
